function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.4342,10.70813c0.99701,-0.86975 2.086,-1.591 3.22443,-2.1496v1.69702c-0.77075,0.43134 -1.492,0.94049 -2.15668,1.52032zM22.1908,10.70813l-1.06067,1.06067c-0.67175,-0.57275 -1.39301,-1.08191 -2.13013,-1.50616v-1.7041c1,0.50116 1.92407,1.10516 2.81329,1.83099zM4.18079,13.8689c0.88385,-0.8689 1.87384,-1.591 2.92743,-2.12134c0.09192,-0.0495 0.18384,-0.1131 0.25452,-0.18384c0.18384,-0.18384 0.28992,-0.43134 0.297,-0.70709v-3.11127c3.01935,-0.98291 6.34027,-0.98999 9.34027,0v3.11835c0,0.38184 0.19153,0.71417 0.51678,0.88385c1.05359,0.53033 2.04358,1.25244 2.92743,2.12134c0.38892,0.38892 1.02533,0.38892 1.41425,0l2.47485,-2.47491c0.38892,-0.39398 0.38892,-1.02527 0,-1.39398c-6.63971,-6.65991 -17.40192,-6.65991 -24.04163,0c-0.38892,0.36871 -0.38892,1 0,1.39398l2.47485,2.47491c0.38892,0.38892 1.02533,0.38892 1.41425,0z",
  fill: "#ffffff",
  fillOpacity: 1
}))));

var SvgCallEnd = function SvgCallEnd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call_end.dbd545b9.svg";
export { ForwardRef as ReactComponent };